export const FORM_CONTACTO_ENDPOINT =
  'https://dev.easysocio.app/api/fing/formulario-de-contacto';
